import { render, staticRenderFns } from "./CadastrarAdministrador.vue?vue&type=template&id=88959baa"
import script from "./CadastrarAdministrador.vue?vue&type=script&lang=js"
export * from "./CadastrarAdministrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports